const codigoBancoBelvo = [
  {
    codigo: 1,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['bancodobrasil_br_retail', 'ofbancodobrasil_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['bancodobrasil_br_business', 'ofbancodobrasil_br_business']
      }
    ]
  },
  {
    codigo: 237,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['bradesco_br_retail', 'ofbradescard_br_retail', 'ofbradesco_br_retail', 'ofnext_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['bradesco_br_business', 'ofbradesco_br_business']
      }
    ]
  },
  {
    codigo: 104,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofcaixa_br_retail', 'caixa_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['caixa_br_business', 'ofcaixa_br_business']
      }
    ]
  },
  {
    codigo: 341,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['itau_br_retail', 'ofitau_br_retail', 'ofitaucard_br_retail', 'itaucard_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['itau_br_business', 'ofitau_br_business']
      }
    ]
  },
  {
    codigo: 623,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofbancopan_br_retail']
      }
    ]
  },
  {
    codigo: 41,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofbanrisul_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofbanrisul_br_business']
      }
    ]
  },
  {
    codigo: 208,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofbtg_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofbtgempresas_br_business']
      }
    ]
  },
  {
    codigo: 655,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofbvapp_br_retail', 'ofbvweb_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofbv_br_business']
      }
    ]
  },
  {
    codigo: 745,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofciti_br_business']
      },
      {
        tipo: 'PJ',
        bancos: ['ofcitibank_br_business']
      }
    ]
  },
  {
    codigo: 335,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofdigio_br_retail', 'ofuberdigio_br_retail']
      }
    ]
  },
  {
    codigo: 323,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofmercadopago_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofmercadopago_br_business']
      }
    ]
  },
  {
    codigo: 4,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofnordeste_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofnordeste_br_business']
      }
    ]
  },
  {
    codigo: 260,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofnubank_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofnubank_br_business']
      }
    ]
  },
  {
    codigo: 380,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofpicpay_br_retail']
      }
    ]
  },
  {
    codigo: 422,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofsafra_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofsafra_br_business', 'ofsafrapay_br_business']
      }
    ]
  },
  {
    codigo: 33,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofsantander_br_retail', 'santander_br_retail', 'ofsantandercard_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofsantander_br_business', 'santander_br_business', 'getnet_br_business']
      }
    ]
  },
  {
    codigo: 756,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofsicoob_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofsicoob_br_business', 'sicoob_br_business']
      }
    ]
  },
  {
    codigo: 748,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofsicredi_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofsicredi_br_business', 'sicredi_br_business']
      }
    ]
  },
  {
    codigo: 136,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofunicred_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofunicred_br_business']
      }
    ]
  },
  {
    codigo: 348,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofxp_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['ofxp_br_business']
      }
    ]
  },
  {
    codigo: 999,
    tipos: [
      {
        tipo: 'PF',
        bancos: ['ofxp_br_retail', 'ofbmg_br_retail']
      },
      {
        tipo: 'PJ',
        bancos: ['pagseguro_br_business', 'ofbmg_br_business', 'inss_br_employment']
      }
    ]
  }
]

function getBelvoInstitutionsByCdBankPersonType (codigo, tipo) {
  // Encontra o item correspondente ao código do banco fornecido
  const item = codigoBancoBelvo.find(dado => dado.codigo === codigo)
  if (!item) {
    return [] // Retorna uma lista vazia se o código não for encontrado
  }
  // Encontra o tipo dentro do item
  const tipoItem = item.tipos.find(t => t.tipo === tipo)
  return tipoItem ? tipoItem.bancos : [] // Retorna os bancos ou uma lista vazia
}

export {
  getBelvoInstitutionsByCdBankPersonType
}



// WEBPACK FOOTER //
// ./client/enum/codigoBancoBelvo.js